<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content >
     <p style="font-weight: bold;" [innerHTML]="data.body"></p>
</div>
